import React from 'react';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';
import { seriesIsEmpty } from '../helpers';
import {
  Controls,
  Header,
  InlineControl,
  LabeledControl,
  Section,
  Selection,
  TextFormat,
} from '../../reporting/sidebar/components';

function LegendControl({ meta }) {
  const { get } = useReportConfiguration();

  return (
    <Section>
      <Header>Legend</Header>
      <Controls>
        <InlineControl>
          <TextFormat
            configurationKey='legendFormat'
            defaultSize={12}
            defaultColor='black'
            defaultFontWeight='normal'
            defaultFontStyle='normal'
            disabled={get('legendAnchor') === null}
          />
        </InlineControl>

        <LabeledControl title='Position'>
          <Selection
            configurationKey='legendAnchor'
            options={[
              ['Top right', 'top-right'],
              ['Center right', 'right'],
              ['Bottom right', 'bottom-right'],
              ['None', null],
            ]}
            disabled={seriesIsEmpty({ meta })}
          />
        </LabeledControl>
      </Controls>
    </Section>
  );
}
export default LegendControl;
